//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.FeatureBendPropertiesBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"Angle",0,"Expression",0],[1,"Distance1",0,"Expression",0],[1,"Distance2",0,"Expression",0],[1,"Edges",0,"ScCollector",0],[0,"Inset",1,0],[1,"Length",0,"Expression",0],[0,"LengthReference",1,0],[0,"Miter",1,0],[1,"Offset",0,"Expression",0],[0,"Point",1,"Point",0],[0,"ReverseDirectionLength",1,0],[0,"ReverseDirectionOffset",1,0],[0,"UseRecipe",1,0],[1,"Width",0,"Expression",0],[0,"WidthOption",1,0]],[[[],"DeleteFlangeBendProperties",{},0,0]],[]];
SPLM.Features.SheetMetal.FlangeBendPropertiesBuilder = class extends SPLM.Features.SheetMetal.FeatureBendPropertiesBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.FlangeBendPropertiesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.FlangeBendPropertiesBuilder.WidthOptions = Object.freeze({
    "Full" : "Full", "AtCenter" : "AtCenter", "AtEnd" : "AtEnd", "FromEnd" : "FromEnd", "FromBothEnds" : "FromBothEnds"});

SPLM.Features.SheetMetal.FlangeBendPropertiesBuilder.LengthReferences = Object.freeze({
    "Inside" : "Inside", "Outside" : "Outside", "Web" : "Web", "Tangent" : "Tangent"});

SPLM.Features.SheetMetal.FlangeBendPropertiesBuilder.Insets = Object.freeze({
    "MaterialInside" : "MaterialInside", "MaterialOutside" : "MaterialOutside", "BendOutside" : "BendOutside", "MaterialInsideOML" : "MaterialInsideOML"});

export default SPLM;